import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {  Typography,  Snackbar, Paper} from '@material-ui/core';
import { formatCurrency } from '../hooks/currency';
import { Chip } from '@material-ui/core';

import OrderPaymentInfo from './OrderPaymentInfo';

const useStyles = makeStyles((theme) => ({

 
  rowMethod: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    borderRadius: "0.5rem",
    backgroundColor: theme.palette.background.grey,
    padding:theme.spacing(1.5),
 
  },

  payment: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    //backgroundColor:'yellow'
  },

  method: {
    margin: theme.spacing(0, 0, 0, 2),
    fontSize: "1rem",
  },

  paymentInfo: {
    display: 'flex',
    flexDirection: 'column',
  
    width: "100%",
    marginTop: theme.spacing(0.5),
  },

  message: {
    margin: 0,
    padding: 0,
    textAlign: 'justify'
  },

  image:{
    width:"28px",
    borderRadius: "10px",
  }, 


}));




export default function OrderPaymentMethod(props) {
  const classes = useStyles();
  const {statusRt, displayPaymentMethod, orderPayMethod, currency,strings } = props;
  const [open, setOpen] = useState(false)
 
  const iconUrl = displayPaymentMethod.iconUrl; 
  const displayName = displayPaymentMethod.name; 

  const getChangeLabel = (change) => {
      return  `${strings.paymethod_cash_change_for} ${formatCurrency(currency, change,false)}`
  }

  const getNotChangeLabel =  `${strings.paymethod_cash_change_for} ${strings.paymethod_cash_no_change}`; 

  const showInfo = ()=>{
    if(displayPaymentMethod?.paymentInfo &&
       !displayPaymentMethod?.paymentInfo.showAfterAccept)
       return true;
  return false;    
} 

  const showInfoAfterAccept = ()=>{
      if(displayPaymentMethod?.paymentInfo &&
         displayPaymentMethod?.paymentInfo.showAfterAccept)
         return true;
    return false;    
  } 
  
  const isAfterAccept = ()=>{
    return (statusRt==='DOING'||
      statusRt==='DELIVERING' ||
      statusRt==='DONE'
      )
} 


  const handleClose = () => {
    setOpen(false);
  };
  
  return (
   
      <div  className={classes.rowMethod}>
        
        <div className={classes.payment}>    
            <img className ={classes.image} src={iconUrl} alt={displayName}  />
          <Typography variant='body' mx={1} > {displayName} </Typography>  
        </div>
           { 
            showInfoAfterAccept() && 
            <OrderPaymentInfo
              strings={strings}
              showInfo = {true}
              isProgress = {!isAfterAccept()}
              orderPayMethod={orderPayMethod}
              displayPaymentMethod = {displayPaymentMethod}
              />
            }
            { 
            showInfo() && !showInfoAfterAccept() && 
            <OrderPaymentInfo
              strings={strings}
              showInfo = {true}
              showInfoProgress = {false}
              orderPayMethod={orderPayMethod}
              displayPaymentMethod = {displayPaymentMethod}
              />
            }
           
            {displayPaymentMethod.paymentInfo?.cashChange && orderPayMethod.change ==0 &&     
              <Typography variant='body2' > {getNotChangeLabel} </Typography>
            }
            {displayPaymentMethod.paymentInfo?.cashChange && orderPayMethod.change >0 &&     
              <Typography variant='body2' > {getChangeLabel(orderPayMethod.change)} </Typography>
            }
         
        <Snackbar
          open={open}
          autoHideDuration={2000}
          onClose={handleClose}
          message={strings.copied_clipboard}
        />

      </div>
  );
}
